<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 6, title: 'pekerjaan' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <p class="sub-title">Data Pekerjaan Pengguna</p>
                    <form @submit.prevent="registerKYC">
                        <div class="form-group">
                            <label for="">Pekerjaan *</label>
                            <select v-model="form.occupation_code" required>
                                <option value="" disabled selected>Pilih pekerjaan</option>
                                <option v-for="(work, i) in pekerjaan" v-bind:key="i" :value="work.code">
                                    {{ work.name }}
                                </option>
                            </select>
                            <div v-show="form.occupation_code == '7'">
                                <label for=""></label>
                                <input
                                    type="text"
                                    class="form-input other-job"
                                    placeholder="Pekerjaan anda saat ini"
                                    v-model="form.other_occupation"
                                    @keyup="form.other_occupation = form.other_occupation.replace(/[^a-zA-Z\s]/g, '')"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Nama perusahaan *</label>
                            <input
                                type="text"
                                maxlength="70"
                                class="form-input"
                                placeholder="Nama perusahaan saat ini"
                                v-model="form.company_name"
                                required
                                @keyup="form.company_name = form.company_name.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">Bidang Usaha *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Bidang usaha"
                                v-model="form.business_sector"
                                @keyup="form.business_sector = form.business_sector.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">Jabatan *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="masukkan jabatan"
                                v-model="form.other_position"
                                @keyup="form.other_position = form.other_position.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label for="">Lama Bekerja *</label>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Saat ini</label>
                            <input
                                type="text"
                                maxlength="2"
                                class="form-input jabatan"
                                v-model="form.work_year"
                                @keyup="form.work_year = form.work_year.replace(/[^\d]/g, '')"
                                required
                            />
                            <span class="tahun">Tahun</span>
                            <input
                                type="text"
                                maxlength="2"
                                class="form-input jabatan mt-2"
                                v-model="form.work_month"
                                @keyup="form.work_month = form.work_month.replace(/[^\d]/g, '')"
                            />
                            <span class="tahun">Bulan</span>
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kantor sebelumnya</label>
                            <input
                                type="text"
                                maxlength="2"
                                class="form-input jabatan"
                                v-model="form.work_year_previous"
                                @keyup="form.work_year_previous = form.work_year_previous.replace(/[^\d]/g, '')"
                                required
                            />
                            <span class="tahun">Tahun</span>
                        </div>
                        <div class="form-group">
                            <label for="">Alamat Kantor *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Alamat perusahaan saat ini"
                                v-model="form.company_address.address"
                                required
                                maxlength="80"
                                @keyup="form.company_address.address = form.company_address.address.replace(/[^a-zA-Z0-9\s,.-]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Provinsi *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Provinsi perusahaan"
                                v-model="form.company_address.province"
                                required
                                @keyup="form.company_address.province = form.company_address.province.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kota *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Kota perusahaan"
                                v-model="form.company_address.regency"
                                required
                                @keyup="form.company_address.regency = form.company_address.regency.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kecamatan *</label>
                            <input
                                type="text"
                                class="form-input"
                                placeholder="Kecamatan perusahaan"
                                v-model="form.company_address.district"
                                required
                                @keyup="form.company_address.district = form.company_address.district.replace(/[^a-zA-Z\s]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kelurahan *</label>
                            <input
                                type="text"
                                class="form-input kecamatan"
                                placeholder="Kelurahan perusahaan"
                                v-model="form.company_address.village"
                                required
                                @keyup="form.company_address.village = form.company_address.village.replace(/[^a-zA-Z\s]/g, '')"
                            />
                            <span class="rt-rw">RT*</span>
                            <input
                                type="text"
                                maxlength="3"
                                class="form-input input-rt-rw"
                                v-model="form.company_address.neighborhood_no"
                                required
                                @keyup="form.company_address.neighborhood_no = form.company_address.neighborhood_no.replace(/[^\d]/g, '')"
                            />
                            <span class="rt-rw rw">RW*</span>
                            <input
                                type="text"
                                maxlength="3"
                                class="form-input input-rt-rw"
                                v-model="form.company_address.citizen_no"
                                required
                                @keyup="form.company_address.citizen_no = form.company_address.citizen_no.replace(/[^\d]/g, '')"
                            />
                        </div>
                        <div class="form-group">
                            <label class="detail-alamat">Kodepos *</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="Masukkan kodepos"
                                v-model="form.company_address.postcode"
                                @keyup="form.company_address.postcode = form.company_address.postcode.replace(/[^\d]/g, '')"
                                minlength="5"
                                maxlength="5"
                                required
                            />
                        </div>

                        <div class="form-group">
                            <label>No Telepon Kantor *</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="8133370...."
                                v-model="form.company_address.telephone"
                                @keyup="form.company_address.telephone = form.company_address.telephone.replace(/[^\d]/g, '')"
                                required
                                maxlength="18"
                            />
                        </div>

                        <div class="form-group">
                            <label>No Faksimile</label>
                            <input
                                type="text"
                                class="form-input pos-telepon"
                                placeholder="8133370...."
                                v-model="form.company_address.fax"
                                @keyup="form.company_address.fax = form.company_address.fax.replace(/[^\d]/g, '')"
                                minlength="5"
                                maxlength="40"
                            />
                        </div>

                        <div class="form-group form-checkbox">
                            <input type="checkbox" class="checkbox" required v-model="form.has_confirm_employment" />
                            <label class="label--checkbox">
                                Dengan ini saya setuju atas seluruh data PEKERJAAN yang saya isi adalah BENAR dan sesuai dengan
                                <span id="toggle-btn" class="ketentuan">Peraturan</span>
                                yang berlaku
                            </label>
                        </div>
                        <div class="button">
                            <router-link to="/register-datakontak"><button class="btn-scondary">Sebelumnya</button></router-link>
                            <button class="btn-primer" type="submit">
                                <div v-show="loading == false">Selanjutnya</div>
                                <Loader class="loading" v-show="loading" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loader from "../assets/Loading";
import HeadRegister from "./component/HeadRegister.vue";

export default {
    components: {
        Loader,
        HeadRegister,
    },
    data() {
        return {
            checkedStatement: false,
            pekerjaan: [],
            loading: false,
            form: {
                occupation_code: "",
                other_occupation: "",
                position_code: "",
                other_position: "",
                business_sector: "",
                industrial_code: "",
                company_name: "",
                work_month: "",
                work_year: "",
                work_year_previous: "",
                has_confirm_employment: false,
                company_address: {
                    address: "",
                    citizen_no: "",
                    neighborhood_no: "",
                    village: "",
                    district: "",
                    regency: "",
                    province: "",
                    telephone: "",
                    fax: "",
                    postcode: "",
                },
                step: "work",
            },
            job: {
                nama: "",
                id: "",
            },
            selectSubDistricts: {
                code: "",
                id: "",
            },
            selectCity: {
                code: "",
                id: "",
            },
            dataProvince: {
                code: "",
                id: "",
            },
            province: "",
            cityKtp: "",
            districtsKtp: "",
            subDistricsKtp: "",
            jabatan: "",
            sendJabatan: {
                nama: "",
                id: "",
            },
            bidangUsaha: "",
            sektorPelanggan: "",
            idEmployment: "",
        };
    },
    mounted() {
        //Get Pekerjaan
        axios.get("/v2/master_data/occupation").then((res) => {
            this.pekerjaan = res.data.data;
        });

        //Get Bidang Usaha
        axios.get("/v2/master_data/industrial").then((res) => {
            this.bidangUsaha = res.data.data;
        });

        //Get Jabatan
        axios.get("/v2/master_data/position").then((res) => {
            this.jabatan = res.data.data;
        });

        this.$store.dispatch("getCustomer").then((res) => {
            this.idEmployment = res._id;
            axios.get("/v2/kyc/employment/" + res._id).then((res) => {
                this.form.occupation_code = res.data.data.employment.occupation_type.code;
                this.form.company_name = res.data.data.employment.company_name;
                this.form.business_sector = res.data.data.employment.business_sector;
                this.form.other_position = res.data.data.employment.other_position;

                // this.form.industrial_code = res.data.data.employment.industrial_type.code;
                // this.form.position_code = res.data.data.employment.position_type.code;
                this.form.work_month = res.data.data.employment.work_month;
                this.form.work_year = res.data.data.employment.work_year;
                this.form.work_year_previous = res.data.data.employment.work_year_previous;
                this.form.has_confirm_employment = res.data.data.employment.has_confirm_employment;

                this.form.company_address.address = res.data.data.employment.company_address.address;
                this.form.company_address.citizen_no = res.data.data.employment.company_address.citizen_no;
                this.form.company_address.fax = res.data.data.employment.company_address.fax;
                this.form.company_address.neighborhood_no = res.data.data.employment.company_address.neighborhood_no;
                this.form.company_address.postcode = res.data.data.employment.company_address.postcode;
                this.form.company_address.province = res.data.data.employment.company_address.province;
                this.form.company_address.regency = res.data.data.employment.company_address.regency;
                this.form.company_address.district = res.data.data.employment.company_address.district;
                this.form.company_address.telephone = res.data.data.employment.company_address.telephone;
                this.form.company_address.village = res.data.data.employment.company_address.village;
            });
        });
    },
    computed: {
        dataCustomer() {
            return this.$store.getters.customerData;
        },

        customerId() {
            let id = this.$store.getters.customerData._id;
            return id;
        },

        datapekerjaan() {
            return this.loadDataPekerjaan();
        },

        idCustomer() {
            return this.idEmployment;
        },
    },
    watch: {
        "dataProvince.code"() {
            if (this.dataProvince.code) {
                this.onCityKtp();
            }
        },
        "selectCity.code"() {
            if (this.selectCity.code) {
                this.onDistrictsKtp();
            }
        },
        "selectSubDistricts.code"() {
            if (this.selectSubDistricts.code) {
                this.subDistrictsKtp();
            }
        },
    },
    methods: {
        registerKYC() {
            if (this.form.work_month == "") {
                this.form.work_month = 0;
            }
            this.loading = true;
            axios
                .put("/v2/kyc/employment/" + this.customerId, this.form)
                .then((res) => {
                    let status = res.data.data.status_code;
                    if (status == "00") {
                        this.loading = false;
                        this.$router.push("/register-datakeuangan");
                    } else if (status == "2004") {
                        this.loading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>Data sudah di submit</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    } else {
                        this.loading = false;
                        this.$notify({
                            group: "foo",
                            title: "<h5>kesalahan sistem</h5>",
                            type: "error",
                            duration: 2000,
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify({
                        group: "foo",
                        title: "<h5>Cek kembali inputan anda</h5>",
                        type: "error",
                        duration: 2000,
                    });
                });
        },
        isNumber(event) {
            const pattern = /[0-9]/;
            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
        isAlphabet(event) {
            const pattern = /^[a-zA-Z\s]*$/;
            let inputChar = String.fromCharCode(event.charCode);
            if (!pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
        isAlphabetSymbol(event) {
            const pattern = /^[a-zA-Z0-9\s,.-]*$/;
            let inputChar = String.fromCharCode(event.charCode);
            if (!pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
        onCityKtp() {
            this.form.company_address.province_type = this.dataProvince.id;
            axios.get("v1/data/regency/" + this.dataProvince.code).then((res) => {
                this.cityKtp = res.data.data.body;
                for (let i = 0; i < this.cityKtp.length; i++) {
                    if (this.cityKtp[i]._id == this.selectCity.id) {
                        this.selectCity.code = this.cityKtp[i].code;
                    }
                }
            });
        },
        onDistrictsKtp() {
            this.form.company_address.regency_type = this.selectCity.id;
            axios.get("/v1/data/district/" + this.selectCity.code).then((res) => {
                this.districtsKtp = res.data.data.body;
                for (let i = 0; i < this.districtsKtp.length; i++) {
                    if (this.districtsKtp[i]._id == this.selectSubDistricts.id) {
                        this.selectSubDistricts.code = this.districtsKtp[i].code;
                    }
                }
                // this.subDistrictsKtp();
            });
        },
        subDistrictsKtp() {
            this.form.company_address.district_type = this.selectSubDistricts.id;
            let id = this.selectSubDistricts.code;
            axios.get("/v1/data/village/" + id).then((res) => {
                this.subDistricsKtp = res.data.data.body;
            });
        },
        async getKyc() {
            return await axios.get("/v2/kyc/employment/" + this.dataCustomer._id);
        },
    },
};
</script>

<style scoped>
.container-outline {
    width: 70%;
}

.form-checkbox {
    margin-top: 50px;
    font-size: 14px;
    color: #707070;
    display: flex;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

.li-active:nth-child(3)::before {
    border: dashed 1px #c59733;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

.form-checkbox {
    margin-top: 50px;
    font-size: 14px;
    color: #707070;
}

label {
    font-size: 14px;
    width: 205px;
    display: inline-block;
}

.detail-alamat {
    width: 175px;
    margin: 0 0 0 30px;
}

.kecamatan {
    width: 40% !important;
    margin-right: 16px;
}

.rt-rw {
    font-size: 13px;
    margin-right: 10px;
}

.rw {
    margin-left: 16px;
}

.input-rt-rw {
    width: 10% !important;
    text-align: center;
}
.form-input {
    width: 73%;
    text-transform: capitalize;
}

.tahun {
    margin: 0 30px 0 20px;
    font-size: 13px;
}

.jabatan {
    height: 35px;
    width: 10%;
    text-align: center;
}

select {
    width: 73%;
    height: 45px;
    text-transform: capitalize;
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 25%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.other-job {
    margin-top: 15px;
}

.pos-telepon {
    width: 25%;
}

.identitas {
    width: 20%;
    margin: 0 32px 0 0;
    background-position-x: 88%;
}

.no-identitas {
    width: 50%;
}

.input-button {
    width: 50px;
    height: 50px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 6px;
    left: -1px;
    border: solid 1px #707070;
    background-color: #6454f0;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}

.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
}

.list-root {
    list-style: none;
    height: 65px;
    width: 40%;
    padding: 20px 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top: solid 2px #000e22;
    border-right: solid 2px #000e22;
    border-bottom: solid 2px #000e22;
    background-color: #1f354a;
    color: white;
    position: relative;
    text-align: center;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #6454f0;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

/* @media (max-width: 1024px){

    .form-input, select{
        width: 68%;
    }

    .pos-telepon{
        width: 25%;
    }
    .jabatan{
        height: 35px;
        width: 10%;
    }
    .nav-root{
        width: 140px;
    }
    .active1{
        left: 115px;
        width: 145px !important;
    }
    .active2{
        left: 235px;
        width: 150px !important;
    }
    .active3{
        left: 361px;
        width: 202px !important;
    }
    .active4{
        left: 537px;
        width: 180px !important;
    }
    .active5{
        left: 691px;
        width: 210px !important;
    }
} */

@media (min-width: 768px) and (max-width: 1190px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label,
    select,
    .form-input,
    .detail-alamat {
        width: 100%;
    }

    .pos-telepon {
        width: 25%;
    }

    .jabatan {
        width: 10%;
    }

    .province,
    .city,
    .kecamatan {
        width: 95%;
        margin-left: 30px;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        margin-left: 15px;
    }

    .button {
        display: block;
        width: 100%;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .jabatan {
        width: 60%;
    }
}
</style>
